"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibilityAdSetToJSON = exports.EligibilityAdSetFromJSONTyped = exports.EligibilityAdSetFromJSON = exports.instanceOfEligibilityAdSet = void 0;
var AgeRange_1 = require("./AgeRange");
var AssetFormat_1 = require("./AssetFormat");
var Gender_1 = require("./Gender");
var Placement_1 = require("./Placement");
var Platform_1 = require("./Platform");
/**
 * Check if a given object implements the EligibilityAdSet interface.
 */
function instanceOfEligibilityAdSet(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "assetFormat" in value;
    isInstance = isInstance && "ageRanges" in value;
    isInstance = isInstance && "genders" in value;
    isInstance = isInstance && "interests" in value;
    isInstance = isInstance && "platforms" in value;
    isInstance = isInstance && "placements" in value;
    return isInstance;
}
exports.instanceOfEligibilityAdSet = instanceOfEligibilityAdSet;
function EligibilityAdSetFromJSON(json) {
    return EligibilityAdSetFromJSONTyped(json, false);
}
exports.EligibilityAdSetFromJSON = EligibilityAdSetFromJSON;
function EligibilityAdSetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'assetFormat': (0, AssetFormat_1.AssetFormatFromJSON)(json['asset_format']),
        'ageRanges': (json['age_ranges'].map(AgeRange_1.AgeRangeFromJSON)),
        'genders': (json['genders'].map(Gender_1.GenderFromJSON)),
        'interests': json['interests'],
        'platforms': (json['platforms'].map(Platform_1.PlatformFromJSON)),
        'placements': (json['placements'].map(Placement_1.PlacementFromJSON)),
    };
}
exports.EligibilityAdSetFromJSONTyped = EligibilityAdSetFromJSONTyped;
function EligibilityAdSetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'asset_format': (0, AssetFormat_1.AssetFormatToJSON)(value.assetFormat),
        'age_ranges': (value.ageRanges.map(AgeRange_1.AgeRangeToJSON)),
        'genders': (value.genders.map(Gender_1.GenderToJSON)),
        'interests': value.interests,
        'platforms': (value.platforms.map(Platform_1.PlatformToJSON)),
        'placements': (value.placements.map(Placement_1.PlacementToJSON)),
    };
}
exports.EligibilityAdSetToJSON = EligibilityAdSetToJSON;
